var App = App || {};

App.Faqs = (function ($) {
    'use strict';

    function init() {

        $(".component-faqs .accordion").each(function () {
            var $showMore = $(this).find(".show-more-button");
            var $showLess = $(this).find(".show-less-button");
            var $hiddenFaqsSection = $(this).find(".hidden-faqs");

            $showMore.click(function () {
                $showMore.addClass("hidden");
                $showLess.removeClass("hidden");
                $hiddenFaqsSection.removeClass("hidden");
            });

            $showLess.click(function () {
                $showMore.removeClass("hidden");
                $showLess.addClass("hidden");
                $hiddenFaqsSection.addClass("hidden");
            });
        });

        AutofocusFAQ();
    }

    function QueryParameter(sParam) {
        var sPageURL = window.location.href.split('?')[1],
            sURLVariables = sPageURL != null ? sPageURL.split('&') : "",
            sParameterName,
            i;
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    }

    function AutofocusFAQ() {
        var searchTerm = QueryParameter("SearchTerm");
        var group = QueryParameter("Group");

        if ((searchTerm != undefined && searchTerm != null && searchTerm.trim() != "") ||
            (group != undefined && group != null && group.trim() != "")) {
            $("div.dropdown").attr("tabindex", "0");
            $("div.dropdown")[0].focus();
        }
        else {
            $("div.dropdown").attr("tabindex", "0");
            $("div.dropdown")[0].focus();
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Faqs.init();
});
